import React from 'react';
import PropTypes from 'prop-types';
import JourneyProp from '../../journey/propTypes/journeyProp';
import JourneyItemRewards from './JourneyItemRewards';
import JourneyItemImage from './JourneyItemImage';
import JourneyItemInfo from './JourneyItemInfo';

export default function JourneyItem({ journey, isFlipped }) {
  return isFlipped ? (
    <div className="row landing-journey-item text-align-right reverse-col">
      <JourneyItemRewards journey={journey} isFlipped={isFlipped} />
      <JourneyItemInfo journey={journey} isFlipped={isFlipped} />
      <JourneyItemImage journey={journey} />
    </div>
  ) : (
    <div className="row landing-journey-item text-left">
      <JourneyItemImage journey={journey} />
      <JourneyItemInfo journey={journey} isFlipped={isFlipped} />
      <JourneyItemRewards journey={journey} isFlipped={isFlipped} />
    </div>
  );
}

JourneyItem.propTypes = {
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  isFlipped: PropTypes.bool,
};

JourneyItem.defaultProps = {
  isFlipped: false,
};
